module.exports = __webpack_public_path__ + "static/media/sms.6206fd75.svg";